import React, {useContext, useState, useEffect} from "react";
//import { ProfileContext } from "../ProfileContext";
import moment from "moment";

const Notification = ({profiledata, profileid}) =>{

    //const {profiledata} = useContext(ProfileContext);
    const [notificationlist, setNotificationList] = useState([]);
    
        useEffect(()=>{
            setNotificationList(profiledata?.notifications || []);
        }, []);

    if(!profiledata)
        return null;

    return(
    <div class="col-md-7">
        <div class="card shadow-sm p-3 profile-notify-height">
            <h6 class="mb-3">Notifications</h6>

            {notificationlist.length === 0 && (
                <div class="crm-empty-state">No follow-up notification found</div>
            )}

            {notificationlist.length > 0 && notificationlist.map((notification, index)=>
                (
                    <div class="crm-notification-list" key={index}>
                        <div class="crm-notification-item">
                            <div class="crm-notification-top">
                                <span class="crm-notification-name">{notification.name}</span>
                                <span class="crm-notification-time">{notification.display_time}</span>
                            </div>
                            <div class="crm-notification-bottom">
                                <span class="crm-notification-mobile"></span>
                                <span class="crm-notification-date">{ moment(notification.display_date).format('DD MMM YYYY') }</span>
                            </div>
                        </div>
                    </div>
                ))
            }
        </div>
    </div>
    );

}

export default Notification;
